import { Injectable } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { extractApiErrorMessage } from 'src/app/shared/utils/api-error-message.util';

@Injectable({ providedIn: 'root' })
export class ErrorHandlingService {
  constructor(private notify: NotificationsService) {}

  errorHandling(err: any): void {
    this.notify.error('', extractApiErrorMessage(err));
  }
}
